import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import { 
    DialogActions, 
    DialogContent, 
    Paper } from 'material-ui';
import Button from 'material-ui/Button';
import {CircularProgress} from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import { translate } from 'react-i18next';
import i18n from '../../services/i18n.js';
import { getUserInformation } from '../Login/loginService';
import { deleteUser } from './userServices';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '16px',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main
    }
});

/**
 * Componente modal que permite eliminar un usuario.
 * Recibe el usuario a eliminar en las props
 * 
 */
class UserDeleteDialog extends React.Component {
    constructor(props){
        super(props);

        this.currentUser = getUserInformation();

        this.state = {
            user:{},
            success: false,
            loading: false        };
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        this.setState({
            success:false, 
            loading: false,
            user: nextProps.user
        });
    }

    tryToCommitSuicide = () =>{
        const loggedUser = getUserInformation();
        return this.state.user.user_name && 
            loggedUser.user_name === this.state.user.user_name;
    }

    handleClose = () => {
        if (!this.state.loading) {
            this.setState({ success: false, loading: true});
        }

        if(this.tryToCommitSuicide()){
            alert(i18n.t('DELETE_USER.DELETE_MYSELF_ERROR'));
            this.setState({
                success: false,
                loading: false
            });
            return;
        }

        this.deleteUser().then(result => {
            if(result.errorCode && result.errorCode !== 200){
                this.setState({
                    success: false,
                    loading: false
                });
                const message = result.message.substring(result.message.indexOf(':')+1).trim();
                alert(i18n.t('DELETE_USER.DELETE_USER_ERROR') + '\n' + message);
                this.props.onClose(false);
            }
            else{
                this.setState({ success: true, loading: false});
                this.props.onClose(true);
            }
        });

    };

    deleteUser = async () => {
        try{
            return await deleteUser(this.state.user);
        } catch (error) {
            return error;
        }
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    render() {

        const { classes, user, t, ...other } = this.props;

        if(!this.state)
            return '';

        const {loading, failed, message} = this.state;

        return (
            <Dialog
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="simple-dialog-title"
                fullWidth={true}
                maxWidth='sm'
                {...other}
            >
                <DialogTitle 
                    id="simple-dialog-title" 
                    disableTypography={true} 
                    className={classes.dialogTitle}>
                    {t('USER.DELETE_USER')}
                </DialogTitle>
                <DialogContent>
                    <Paper style={{ padding: '12px' }} elevation={0}>

                        <Typography style={{
                            fontSize: '16px',
                            textAlign: 'center'
                        }}>
                            <span className={classes.roomPos}>
                                {t('USER.DELETE_LABEL')}
                            </span>
                        </Typography>
                        <span></span>
                        <Typography style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            textAlign: 'center'
                        }}>
                            <span className={classes.roomPos}>
                                {user.user_name}
                            </span>
                        </Typography>
                        {failed ? (
                            <label>{t(message)}</label>
                        ) : (
                            ''
                        )}
                    </Paper>
                </DialogContent>
                <DialogActions className={classes.root} style={{ padding: '12px' }}>
                    <div className={classes.wrapper}>
                        <Button
                            disabled={loading}
                            onClick={this.handleCancel}
                        >
                            { t('COMMON.CANCEL') }
                        </Button>
                    </div>
                    <div className={classes.wrapper}>
                        <Button
                            variant="raised"
                            color="secondary"
                            disabled={loading}
                            onClick={this.handleClose}
                        >
                            {t('USER.DELETE_USER')}
                        </Button>
                        {
                            loading && 
                            <CircularProgress 
                                size={24} 
                                className={classes.buttonProgress} 
                            />
                        }
                    </div>
                </DialogActions>
            </Dialog>
        );
    }
}

UserDeleteDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(UserDeleteDialog));


// WEBPACK FOOTER //
// ./src/components/User/UserDeleteDialog.js